import { useState } from "react";

interface UseStoreSelectionProps {
  initialSelectedIds?: string[];
}

export const useStoreSelection = ({ initialSelectedIds = [] }: UseStoreSelectionProps = {}) => {
  const [activeStoreId, setActiveStoreId] = useState<string | null>(null);
  const [selectedStoreIds, setSelectedStoreIds] = useState<string[]>(initialSelectedIds);

  const toggleStoreSelection = (storeId: string) => {
    setSelectedStoreIds(prev => {
      if (prev.includes(storeId)) {
        return prev.filter(id => id !== storeId);
      }
      return [...prev, storeId];
    });
  };

  const isStoreSelected = (storeId: string) => selectedStoreIds.includes(storeId);

  return {
    activeStoreId,
    setActiveStoreId,
    selectedStoreIds,
    toggleStoreSelection,
    isStoreSelected,
  };
};
